export default "__VITE_ASSET__B8yJnj7r__"